export const getFieldFormAddress = (address, fields) => {
    const attr = fields.includes('route') ? 'short_name' : 'long_name';

    for (const field of fields) {
        const component = address.address_components.find((a) => a.types.includes(field));
        if (component) {
            return component[attr];
        }
    }

    return null;
};

export const locationAddressFromGeocode = async (geocodeResult, latitude, longitude) => {
    const streetName = getFieldFormAddress(geocodeResult, ['route']);
    const streetNumber = getFieldFormAddress(geocodeResult, ['street_number']);
    const street = streetName == null || streetNumber == null ? null : [streetNumber, streetName].join(' ');
    const { default: tz_lookup } = await import('tz-lookup');

    return {
        address: geocodeResult.formatted_address,
        street,
        country: getFieldFormAddress(geocodeResult, ['country']),
        zip: getFieldFormAddress(geocodeResult, ['postal_code']),
        state: getFieldFormAddress(geocodeResult, ['administrative_area_level_1']),
        city: getFieldFormAddress(geocodeResult, ['locality', 'sublocality', 'administrative_area_level_3', 'neighborhood']),
        latitude,
        longitude,
        ...(latitude != null && longitude != null && { timezone: tz_lookup(latitude, longitude) }),
    };
};
